module.exports = __webpack_public_path__ + "img/add-remarks-icon.4418f72c.svg";